import classes from './Box.module.scss';
import info from './IPhone141.module.scss';
import { Splide, SplideSlide } from "@splidejs/react-splide";
import '@splidejs/react-splide/css';
import { Group1,Group2,Group3,Group4 } from './Group/Group';
import React from 'react';
import { useState } from "react";
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faArrowUpRightFromSquare,faStar} from "@fortawesome/free-solid-svg-icons";

type BoxProps = {
  className?: string;
  classes?: {
    root?: string;
  };
  children: React.ReactNode;
}

export const Box = ({ className, children }: BoxProps) => {
  return (
    <div className={`${classes.root}`}>
      <div className={classes.Box}>
        {children}
      </div>
    </div>
  );
};
export const INFO = ({ className = '' }) => {
  return (
    <Box className={className} >
      <div className={classes.List}>
  <div className={classes.ListItem}>
    <p className={classes.ListItemTitle}>開催日:</p>
    <p className={`${info.textBlock} ${classes.ListItemText}`}>2024年5月26日　10：30～15：00</p>
  </div>
  <div className={classes.ListItem}>
    <p className={classes.ListItemTitle}>イベント名:</p>
    <p className={`${info.textBlock} ${classes.ListItemText}`}>どうやら出番のようだ! 39</p>
  </div>
  <div className={classes.ListItem}>
    <p className={classes.ListItemTitle}>サークル名:</p>
    <p className={`${info.textBlock} ${classes.ListItemText}`}>888 はち/プラーシ</p>
  </div>
  <div className={classes.ListItem}>
    <p className={classes.ListItemTitle}>スペース:</p>
    <p className={`${info.textBlock} ${classes.ListItemText}`}>5号館 ほ45b</p>
  </div>
  <div className={classes.ListItem}>
    <p className={classes.ListItemTitle}>カテゴリー:</p>
    <p className={`${info.flex} ${classes.ListItemText}`}><Group4 /><Group2 /></p>
    
  </div>
  </div>
    </Box>
  );
};

const STAR = () => {
  const [isActive, setIsActive] = useState(false); // isActiveの初期値はfalseとする
  const handleClick = () => {setIsActive(!isActive); }; // isActiveの状態を反転させる
  return (
    <div style={{
          position: "absolute",
          bottom: "10px",
          right: "10px",
        }}>
      <FontAwesomeIcon icon={faStar}
        onClick={handleClick}
        style={{ color: isActive ? '#FFC800' : '#888' }} // isActiveの状態に応じてアイコンのスタイルを変更する
      /></div>);};
export default STAR;

export const NEWBOOK = ({ className = '' }) => {
  return (
    <Box className={className} >
      <p style={{ position: "relative" }}>
      <Splide aria-label="エンプティワイングラス" options={ { rewind: true, type: 'loop',} }>
  <SplideSlide>
    <img src="./assets/hyosi.jpg" alt=""/>
  </SplideSlide>
  <SplideSlide>
    <img src="./assets/hyosiura.jpg" alt=""/>
  </SplideSlide>
  <SplideSlide>
    <img src="./assets/htk1.jpg" alt=""/>
  </SplideSlide>
  <SplideSlide>
    <img src="./assets/htk2.jpg" alt=""/>
  </SplideSlide>
  <SplideSlide>
    <img src="./assets/novelty.jpg" alt=""/>
  </SplideSlide>
</Splide>
        <STAR/></p>
      <div className={`${info.image} ${info.rectangle10}` }></div>
      <div className={info.flex}>
      <h2 className={info.h2}>エンプティワイングラス</h2><Group4 /></div>
      <h3 className={info.h3}>A5 / 24p / 全年齢</h3>
      <div className={info.caption}>
        個性事故によりちょっと様子のおかしい常闇くんと、ちょっと鈍感なホークスのお話。<br/>
      特典にコースターセットが付属します。サラサラのベルベットPPになる予定。<br/>
      委託通販はイベント当日10:00に予約が開始され、URLが公開になるようです。</div>
      <div className={info.flexAround}>
      <div className={info.h3}>※イベント価格</div>
      <div className={info.yen}>¥ 400</div></div>
      {/*<Button
          title="Button with icon component"
          onClick={() => window.open('', '_blank')}
        variant="danger">
        sample <FontAwesomeIcon icon={faArrowUpRightFromSquare}/>
  </Button>*/}
      <Button
          title="Button with icon component"
          onClick={() => window.open('https://www.melonbooks.co.jp/fromagee/detail/detail.php?product_id=2415756', '_blank')}
        variant="danger">
        フロマージュ <FontAwesomeIcon icon={faArrowUpRightFromSquare}/>
      </Button>
    </Box>
  );
};

export const POSTCARD = ({ className = '' }) => {
  return (
    <Box className={className} >
      <p style={{ position: "relative" }}>
      <Splide aria-label="ポストカードセット" options={ { rewind: true, type: 'loop',} }>
      <SplideSlide>
    <img src="./assets/novelty2.jpg" alt=""/>
  </SplideSlide>
</Splide>
        <STAR/></p>
      <div className={`${info.image} ${info.rectangle10}` }></div>
      <div className={info.flex}>
      <h2 className={info.h2}>ポストカードセット</h2><Group2 /></div>
      <h3 className={info.h3}>サイズ ポストカード / ミランダスノーホワイト</h3>
      <div className={info.caption}>
      表紙デザインのポストカード2枚セットです。</div>
      <div className={info.flexAround}>
      <div className={info.h3}>※イベント価格</div>
      <div className={info.yen}>¥ 100</div></div>
      <Button
          title="Button with icon component"
          style={{width: '97%'}}
          onClick={() => window.open('https://www.melonbooks.co.jp/fromagee/detail/detail.php?product_id=2414852', '_blank')}
        variant="danger">
        フロマージュ <FontAwesomeIcon icon={faArrowUpRightFromSquare}/>
      </Button>
    </Box>
  );
};

export const NEWITEM = ({ className = '' }) => {
  return (
    <Box className={className} >
      <p style={{ position: "relative" }}>
      <Splide aria-label="ホー常アクキーセット【再再販】" options={ { rewind: true, type: 'loop',} }>
  <SplideSlide>
    <img src="./assets/item1-01.jpg" alt=""/>
  </SplideSlide>
  <SplideSlide>
    <img src="./assets/item1-02.jpg" alt=""/>
  </SplideSlide>
  <SplideSlide>
    <img src="./assets/item1-03.jpg" alt=""/>
  </SplideSlide>
  <SplideSlide>
    <img src="./assets/novelty.jpg" alt=""/>
  </SplideSlide>
</Splide>
        <STAR/></p>
      <div className={`${info.image} ${info.rectangle10}` }></div>
      <div className={info.flex}>
      <h2 className={info.h2}>ホー常アクキーセット【再再販】</h2><Group2 /></div>
      <h3 className={info.h3}>サイズ 各50×50mm / ストラップ(金)付き / アクリル部分がちょっとピンク色</h3>
      <div className={info.caption}>
      アクリルチャーム ホークス・常闇セット<br/>
画像2枚目が1セットの内容になります。つながります。<br/>
※各数バラつかないようセットにしております。</div>
      <div className={info.flexAround}>
      <div className={info.h3}>※イベント価格</div>
      <div className={info.yen}>¥ 500</div></div>
      <Button
          title="Button with icon component"
          style={{width: '97%'}}
          onClick={() => window.open('https://www.melonbooks.co.jp/fromagee/detail/detail.php?product_id=1961962', '_blank')}
        variant="danger">
        フロマージュ <FontAwesomeIcon icon={faArrowUpRightFromSquare}/>
      </Button>
      {/*<Button
          title="Button with icon component"
          onClick={() => window.open('https://nnaw08.booth.pm/items/2209713', '_blank')}
        variant="danger">
        BOOTH <FontAwesomeIcon icon={faArrowUpRightFromSquare}/>
  </Button>*/}
    </Box>
  );
};
export const ITEM = ({ className = '' }) => {
  return (
    <Box className={className} ><div style={{ position: "relative" }}>
      <Splide aria-label="ホー常おでかけアクスタ" options={ { rewind: true, type: 'loop',} }>
  <SplideSlide>
    <img src="./assets/item2-01.jpg" alt=""/>
  </SplideSlide>
  <SplideSlide>
    <img src="./assets/item2-02.jpg" alt=""/>
  </SplideSlide>
  <SplideSlide>
    <img src="./assets/item2-03.jpg" alt=""/>
  </SplideSlide>
  <SplideSlide>
    <img src="./assets/item2-04.jpg" alt=""/>
  </SplideSlide>
</Splide>
<STAR/></div>
      <div className={`${info.image} ${info.rectangle10}` }></div>
      <div className={info.flex} style={{paddingTop: "10px"}}>
      <h2 className={info.h2}>ホー常おでかけアクスタ</h2><Group2 /></div>
      <h3 className={info.h3}>50mm×50mm / 両面印刷 / 台座・ボールチェーン付き</h3>
      <div className={info.caption}><strong>※イベント、通販ともに残部少です。</strong><br/>
        あなたの前をデート中のホー常が通過します。<br/>
      台座は保護シートの付いた状態でお届けします。お手数ですが両面剥がして頂くと芝生のような透明の台座になります。<br/>
台紙……裏面はペーパースタンドにできるかも…？
      </div>
      <div className={info.flexAround}>
      <div className={info.h3}>※イベント価格</div>
      <div className={info.yen}>¥ 400</div></div>
      <Button
          title="Button with icon component"
          style={{width: '97%'}}
          onClick={() => window.open('https://www.melonbooks.co.jp/fromagee/detail/detail.php?product_id=1961961', '_blank')}
        variant="danger">
        フロマージュ <FontAwesomeIcon icon={faArrowUpRightFromSquare}/>
      </Button>
      {/*<Button
          title="Button with icon component"
          onClick={() => window.open('https://nnaw08.booth.pm/items/3885990', '_blank')}
        variant="danger">
          BOOTH <FontAwesomeIcon icon={faArrowUpRightFromSquare}/>
  </Button>*/}
    </Box>
  );
};

export const KAKO = ({ className = '' }) => {
  return (
    <Box className={className} ><div style={{ position: "relative" }}></div>
      <div className={info.flex} style={{paddingTop: "10px"}}>
      <h2 className={info.h2}>過去絵まとめ</h2><Group1 /></div>
      <h3 className={info.h3}>ホー常 / CPなし ２件分</h3>
      <div className={info.caption}>約2年分の作品を傾向別に分けました。<br/>ポイピクや過去のネップリも含まれます。イベント期間にアップします。
      </div>
      <Button
          title="Button with icon component"
          style={{width: '97%'}}
          onClick={() => window.open('https://www.pixiv.net/users/2287439', '_blank')}
        variant="danger">
        PIXIV <FontAwesomeIcon icon={faArrowUpRightFromSquare}/>
      </Button>
    </Box>
  );
};

function Modal({ show, setShow }: { show: boolean, setShow: React.Dispatch<React.SetStateAction<boolean>> }) {
  const closeModal = () => {
    setShow(false);
  };
  if (show) {
  return (
    <div onClick={closeModal} className={classes.overlay}>
      <div className={`${classes.caption} ${classes.content}` }onClick={(e) => e.stopPropagation()}>
      <Splide aria-label="展示作品" options={ { rewind: true, type: 'loop',} }>
  <SplideSlide>
  <img src="./assets/0603.jpg" alt="" />
  </SplideSlide>
</Splide>
        <div><Button onClick={closeModal}>close</Button></div>
      </div>
    </div>
)
} else {
  return null;}
}

export const GALLERY = ({ className = '' }) => {
  const [show, setShow] = useState(false)
  const openModal = () => {
    setShow(true)
  }
  return (
    <Box className={className} >
      <p style={{ position: "relative" }}><img src="./assets/0603.jpg" alt="" />
        <STAR/></p>
      <div className={`${info.image} ${info.rectangle10}` }></div>
      <div className={info.flex}>
      <h2 className={info.h2}>ネットプリント</h2><Group1 /><Group3 /></div>
      <div className={info.caption}>
        ファミマ・ローソン：Z9HQTQDPG8<br/>
38巻のちいちゃい常闇くんと黒影が、もこもこ愛されお洋服のホークスと遊んでいるパロです（季節外れ）フチなしありどちらでも
      </div>
      <Button
          title="Button with icon component"
          style={{width: '97%'}}
        variant="warning"
        onClick={openModal}>
        SHOW
      </Button>
      <Modal show={show} setShow={setShow}/>
    </Box>
  );
};